<template>
  <component
    :is="currentComponent"
    v-bind="attributes"
    :class="['c-unit-tile', { 'c-unit-tile--no-cover': cover }]"
  >
    <img v-if="cover" class="c-unit-tile__img" :src="cover" />
    <div v-else class="c-unit-tile__img--empty" />
    <div class="c-unit-tile__title">
      <VHeading
        v-if="index !== undefined"
        header="h3"
        class="c-unit-tile__number"
      >
        {{ index + 1 }}
      </VHeading>
      <VHeading header="h3" class="c-unit-tile__title-text">
        {{ title }}
      </VHeading>
    </div>
  </component>
</template>

<script>
import VHeading from '@forlagshuset/v-heading'

export default {
  components: {
    VHeading,
  },
  props: {
    index: Number,
    title: String,
    slug: String,
    cover: String,
    target: {
      type: String,
      default: '_parent',
    },
  },
  setup(props) {
    const currentComponent =
      props.slug.indexOf('http') !== -1 ? 'a' : 'router-link'
    let attributes = {}

    if (currentComponent === 'router-link') {
      attributes = {
        to:
          props.slug.indexOf('/concretes/') !== -1
            ? props.slug
            : `/unit/${props.slug}`,
        target: props.target,
      }
    } else {
      attributes = {
        href: props.slug,
        target: props.target,
      }
    }

    return {
      currentComponent,
      attributes,
    }
  },
}
</script>
